import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import axios from 'axios'
import { FilterTable, Link } from 'camino-react'

import { stripTags } from 'Utilities/StringManipulator'

const LevelCell = ({ noticesItems, clients }) => {
  const groupedNoticesItems = _.groupBy(noticesItems, 'type')

  return _.map(groupedNoticesItems, (item, key) => (
    <div key={key} className="truncated">
      {`${key}: `}
      <ItemsList noticesItems={item} clients={clients} />
    </div>
  ))
}

const ItemsList = ({ noticesItems, clients }) => {
  let noticeItemLink = ''

  const listOfItems = _.map(noticesItems, (noticeItem) => {
    const { type, id } = noticeItem

    if (type === 'Ticket' || type === 'Problem') {
      noticeItemLink = `${_.lowerCase(type)}s/${id}`
    }

    return (type === 'Client' ? _.find(clients, { id }).short_name : `#${id}`)
  }).join(', ')

  return (
    <Link href={noticeItemLink}>
      {listOfItems}
    </Link>
  )
}
class NoticesContainer extends Component {
  constructor (props) {
    super(props)

    const defaultFilters = [
      {
        type: 'regex',
        value: ''
      }
    ]

    this.state = {
      loading: true,
      clients: [],
      users: [],
      filters: defaultFilters
    }
  }

  componentDidMount = async () => {
    const clients = await this.fetchClients()
    const users = await this.fetchUsers()

    this.setState({
      clients: clients.data,
      users: users.data,
      loading: false
    })
  }

  fetchClients = async () => {
    const { notices } = this.props

    const clientNotices = _.flatMap(notices, ({ notices_items: noticesItems }) => _.filter(noticesItems, { type: 'Client' }))

    const clientIds = _.map(clientNotices, ({ id }) => id)

    if (_.isEmpty(clientIds)) {
      return []
    }
    return axios.get('/api/clients', {
      params: {
        client_ids: clientIds
      }
    })
  }

  fetchUsers = async () => {
    const { notices } = this.props

    const userIds = _.uniq(_.map(notices, ({ creator_id: id }) => id))

    if (_.isEmpty(userIds)) {
      return []
    }

    return axios.get('/api/users', {
      params: {
        user_ids: userIds.join(',')
      }
    })
  }

  render () {
    const {
      loading, filters, clients, users
    } = this.state
    const { notices } = this.props

    const textFilter = _.find(filters, filter => (
      (filter.type === 'regex') && (typeof filter.on === 'undefined')
    ))

    const tableData = _.map(notices,
      notice => Object.assign(
        {}, notice, { creator: (_.find(users, { id: notice.creator_id }) || {}).name }
      ))

    const columns = [{
      text: 'ID',
      accessor: 'id',
      Cell: row => (
        <span>
          {row.value}
        </span>
      )
    }, {
      text: 'Content',
      accessor: 'content',
      Cell: row => (
        <Link href={row.original.notice_href}>
          {stripTags(row.value)}
        </Link>)
    }, {
      text: 'Level',
      accessor: 'notices_items',
      Cell: row => (
        loading ? '' : <LevelCell noticesItems={row.value} clients={clients} />
      )}, {
      text: 'Creator',
      accessor: 'creator',
      maxWidth: 150
    }]

    return (
      <section className="card card--padding-large">
        <FilterTable
          columns={columns}
          loading={loading}
          data={tableData}
          noDataText="You currently have no notices"
          localStoragePrefix="NoticesTable"
        />
      </section>
    )
  }
}

NoticesContainer.defaultProps = {
  notices: []
}

NoticesContainer.propTypes = {
  notices: PropTypes.arrayOf(PropTypes.object)
}

export default NoticesContainer
